import React, {useEffect} from "react";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import * as snackbarActions from "../../../actions/snackbarActions"
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import MainSnackbar from "../../Utils/Snackbar/SmsSnackbar";
import {BackButton} from "../../Utils/Buttons/DataExportationButton";
import {Container} from "../../Utils/styledComponents"
import axios from "axios";
import { config } from "../../../Helpers/env";
import {errorMessages} from "../../../Helpers/ErrorMessages";
import {CustomTableCell, MuiPaper, StickyHeadTable} from "../../Utils/Tables/StickyHeaderTable";
import {LoadingGif} from "../../Utils/Loader";
import PageTitle from "../../Utils/smsTitle";
import {SubHeader} from "../../../Containers/SubHeader";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClipboardList} from "@fortawesome/free-solid-svg-icons/faClipboardList";
import { CustomTablePagination, EnhancedSearchTableToolbar } from "../../Utils/Tables/CustomTable";
import {ReusableRouteTabs} from "../../Utils/Dialogs/ReusableTabs";
import {history} from "../../../Helpers/history";



const headData = [
    {id: 'no', numeric: false, disablePadding: false, label: 'No.'},
    {id: 'customer_name', numeric: false, disablePadding: false, label: 'Customer Name'},
    {id: 'total_debt', numeric: false, disablePadding: false, label: 'Total Debt'},
];

const AccountReceivables = ({actions, snackbars, match:{params}}) => {
    const [data, setData] = React.useState({debtors:[], loading:'idle', total_count:0});
    const [state, setState] = React.useState({start_date:'', end_date:''});
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(50);
    const [submitted, setSubmitted] = React.useState(false);
    const [isSubmitted, setIsSubmitted] = React.useState('idle');
    const {debtors, loading, total_count} = data
    const {component} = params
    const isCustomer = component === 'customer';
    const [activePage, setActivePage] = React.useState(1);
    const [term, setTerm] = React.useState('');
    const {start_date, end_date} = state

    const isResolved = isSubmitted === 'resolved';

    useEffect(() => {
        setData({...data, loading: 'pending'})
        axios.get(`${config.smsUrl}/cbilling/debtors`, {
            params: {
                page:activePage,
                search:term,
                per_page:rowsPerPage
        }}).then(res => {
            const response = res.data;
            const arr = response ? response : [];
            const debt_arr = arr.length > 0 ? arr[0].provider_debt : []; 
            const count = arr.length > 0 ? arr[0].total_count : 0; 
            setData({debtors: debt_arr, loading: 'success', total_count:count})
        }).catch(err => {
            errorMessages(err, null, actions);
            setData({...data, loading: 'error'});
        })
    }, [isResolved, activePage, term, rowsPerPage])

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        setActivePage(newPage+1);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
        setActivePage(1);
    };

    const handleChange = (event) =>{
        const {value, name} = event.target;
        setState({...state,[name]:value})
    }

    const closeSnackbar = () =>{
        actions.snackbarActions.hideSnackbar();
    };

    const handleSubmit = (event) =>{
        event.preventDefault()
        setSubmitted(true)
        if (start_date && end_date){
            setIsSubmitted('resolved')
        }
    }

    const isLoading = loading === 'pending'
    const isSuccess = loading === 'success'
    const isError = loading === 'error'

    const isPending = isSubmitted === 'pending'

    const {openBar, type, message} = snackbars;
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, debtors.length - page * rowsPerPage);

    const handler = (event) => {
        setTerm(event.target.value)
    }

    const pagination = (
        <CustomTablePagination
            colSpan={3}
            activePage={activePage}
            page={page}
            rowsPerPage={rowsPerPage}
            count={total_count}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            isTotalCount
        />
    );

    const search_bar = (
            <EnhancedSearchTableToolbar
            term={term} handler={handler}
            />
    )

    const components = [
        {label: 'Unpaid Invoices', path: '/customerreceivables'},
        {label: 'Paid Invoices', path: '/paidcustomerreceivables'},
    ]

    return (
        <div>
            <PageTitle title="Customer Receivables"/>
            <SubHeader title="Reports" subTitle="Customer Receivables">
                <FontAwesomeIcon icon={faClipboardList}/>
            </SubHeader>
            <Container>
                {!isCustomer ?
                    <div className='mb-3'>
                        <BackButton to='/reports/generalreports' text='General Reports'/>
                    </div>:null}
                {!isCustomer ? <ReusableRouteTabs value={history.location.pathname} tabHeading={components}/>: null}

                <MainSnackbar open={openBar} message={message} variant={type} handleCloseBar={closeSnackbar}/>
                <MuiPaper>
                    {search_bar}
                    <StickyHeadTable {...{width:'100%',data:debtors, columns:headData.filter(item=>Boolean(item)), pagination, search_bar}}>
                        {isLoading ? <TableRow><TableCell align='center' {...{colSpan:headData.length}}><LoadingGif/></TableCell></TableRow>:null}
                        {isSuccess ? debtors.length > 0 ?
                            <>
                                {debtors.filter(row=>row.total_debt).slice(0, rowsPerPage).map((row, index) => {
                                    const count = ((activePage - 1) * rowsPerPage) + index + 1;
                                    return (
                                        <TableRow  tabIndex={-1} key={index}>
                                            <CustomTableCell>{count}</CustomTableCell>
                                            <CustomTableCell><Link to={{pathname:`/invoicereportdetails/${row.customer_id}/${row.provider_name}/unpaid`}}>
                                                {row.provider_name}</Link></CustomTableCell>
                                            <CustomTableCell>{row.total_debt ? `${row.currency_symbol} ${row.total_debt}` : 0}</CustomTableCell>
                                            {/* <CustomTableCell>{row.amount_paid}</CustomTableCell>
                                        <CustomTableCell>{row.total_debt - row.amount_paid}</CustomTableCell> */}
                                        </TableRow>
                                    );
                                })}
                                {emptyRows > 0 && (
                                    <TableRow style={{ height: 5 * emptyRows }}>
                                        <TableCell colSpan={headData.length} />
                                    </TableRow>
                                )}
                            </>:<TableRow><TableCell align='center'  {...{colSpan:headData.length}}>No records found</TableCell></TableRow>:null}
                        {isError ? <TableRow><TableCell align='center'  {...{colSpan:headData.length}}>The server did not return a valid response</TableCell></TableRow>:null}
                    </StickyHeadTable>
                </MuiPaper>

            </Container>
        </div>
    )
};

function mapStateToProps(state) {
    return {snackbars: state.snackbar}
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            snackbarActions: bindActionCreators(snackbarActions, dispatch)
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountReceivables);
